module.exports = __webpack_public_path__ + "img/law.d769008.d83af155.png";